import React, { useEffect, useRef } from "react";
import { query } from "../utils/utils";
import { initFocusVisible } from "../utils/vendor/focus-visible";

const Sub3Navigation = ({
  setSub3NavigationItems,
  sub3NavigationItems,
  getNavigationData,
  sub3NavigationRoot,
  setHeight,
  height,
  isLoading,
}) => {
  const pageHeader = query("#page-header");
  const layerInner = query(".desktop-layer-inner", pageHeader);

  const ref = useRef(0);
  // States
  let baseUrl = document.body.dataset.baseUrl;

  // Set new height after loading and if its higher
  useEffect(() => {
    if (!isLoading) {
      if (height < ref.current.clientHeight) {
        setHeight(ref.current.clientHeight);
      }
    }
  }, [isLoading]);

  // fill the state on mount
  useEffect(() => {
    if (sub3NavigationRoot) {
      getNavigationData(sub3NavigationRoot["@id"], false, false, false, true);
    }
    if (!isLoading) {
      setHeight(ref.current.clientHeight);
    }
  }, []);

  /**
   * Render the title part of the subnavigation.
   *
   * @return {*} JSX code.
   *
   *
   */
  function sub3NavigationTitle() {
    return (
      <span>
        <span className="d-flex ai-center w-100 case-upper">
          {sub3NavigationRoot["title"]}
        </span>
      </span>
    );
  }

  /**
   * Render the navigation items.
   *
   * @return {*} JSX code.
   * @memberof SlwfNavigation
   *
   *
   */
  function _renderSub3NavigationItems() {
    let itemStructure = (
      <>
        {sub3NavigationItems?.items.map((item) => {
          let klass = "link-outer d-flex ai-center w-100";
          if (item["@id"] === baseUrl) {
            klass += "inpath";
          }
          return (
            <li
              className="menu-tree-level sans-m1"
              key={item["@id"].toString()}
            >
              <a
                href={item["@id"]}
                className="link-outer d-flex ai-center w-100"
              >
                <span>
                  <span className="link-inner">{item["title"]}</span>
                </span>
              </a>
            </li>
          );
        })}
      </>
    );

    return itemStructure;
  }

  return (
    <div
      role="region"
      id="menu-tree-level-content-GKCUatcvx0fQWX-nuqPD2"
      aria-hidden="true"
      ref={ref}
      className="menu-tree-child stack-s"
    >
      {sub3NavigationTitle()}
      <ul className="stack-xs">{_renderSub3NavigationItems()}</ul>
    </div>
  );
};

export default Sub3Navigation;
